<div class="dark">
  <router-outlet></router-outlet>
</div>
